let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fuqpx")).then(() => parcelRequire('4zI6N'));